import { render, staticRenderFns } from "./CreatePositionTemplateModal.vue?vue&type=template&id=2553d5df&scoped=true&"
import script from "./CreatePositionTemplateModal.vue?vue&type=script&lang=js&"
export * from "./CreatePositionTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./CreatePositionTemplateModal.vue?vue&type=style&index=0&id=2553d5df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2553d5df",
  null
  
)

export default component.exports